<script setup lang="ts">
import type { PropType } from 'vue'
import { reformatDate } from '@/utils/date'
import type { Category } from '@/models/content'
import { TIME_FORMAT } from '@/constants/app'

const props = defineProps({
  categories: {
    type: Array as PropType<Category[]>,
    required: true,
  },
  publishedDate: {
    type: String,
    required: true,
  },
  duration: {
    type: Number,
    required: true,
  },
  twitterLink: {
    type: String,
    default: null,
  },
  linkedInLink: {
    type: String,
    default: null,
  },
})

const formattedDate = computed(() =>
  reformatDate(props.publishedDate, TIME_FORMAT, 'do MMMM yyyy'),
)

const formattedDuration = useFormattedDuration('article', props.duration)
</script>

<template>
  <div class="border-b-2 border-t-2 border-s-200 py-2">
    <p class="text-sm font-semibold">{{ formattedDate }}</p>
    <p class="mt-1 text-sm">{{ formattedDuration }}</p>
    <div v-if="categories.length" class="mt-3 flex flex-wrap gap-2">
      <LinkedPill
        v-for="category in categories"
        :key="category.id"
        type="category"
        :slug="category.slug"
        variant="black"
        data-testid="article-category-tag"
      >
        {{ category.name }}
      </LinkedPill>
    </div>

    <div class="mt-4 flex items-center gap-x-2">
      <p class="text-xs">Share Article</p>

      <SocialLinks
        class="gap-x-2"
        icon-classes="h-4 w-4 fill-s-900"
        hide-newsletter
        :twitter-link="twitterLink"
        :linked-in-link="linkedInLink"
      />
    </div>
  </div>
</template>
